import React, { useState } from "react";
import { Row, Col, Card, Button } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { EMAIL_REGX } from "../../config/variables";
import { formatToNumber } from "../../config/utils";
import { useDispatch } from "react-redux";
import { AuthAction } from "../../store/actions";
import CreateProfile from "../../assets/images/createPro.png";
import Profile_success from "../../assets/images/profile_success.png";
import CustomModal from "../../components/modals/customModal";
import LoaderGif from "../../assets/images/ie_loader.gif";
import { useHistory } from "react-router-dom";

const Register = ({ count, onChangeStep, userData, loader }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [contactInfo, setInfo] = useState({
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  console.log("conttttt", contactInfo);
  const [isOpenModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState({
    first_nameError: "",
    last_nameError: "",
    emailError: "",
    phoneError: "",
    passwordError: "",
    confirm_passwordError: "",
  });

  const handleChange = (e) => {
    const newValue = e.target.value;
    const formattedValue = formatToNumber(newValue);
    // setInputValue(formattedValue);
    setInfo({ ...contactInfo, phone: formattedValue })
  };

  const onChangeContactInfo = (e) => {
    setInfo({
      ...contactInfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };

  const onSubmit = () => {
    let first_nameError = "";
    let last_nameError = "";
    let phoneError = "";
    let emailError = "";
    let passwordError = "";
    let confirm_passwordError = "";
    if (
      !contactInfo?.first_name.trim().length ||
      !contactInfo?.last_name.trim().length ||
      !contactInfo?.phone.trim().length ||
      !EMAIL_REGX.test(contactInfo.email) ||
      !contactInfo?.password.trim().length ||
      !contactInfo?.confirm_password.trim().length ||
      contactInfo.password !== contactInfo.confirm_password ||
      contactInfo?.password.trim().length < 8
    ) {
      if (!contactInfo?.first_name.trim().length) {
        first_nameError = "First name is required.";
        setErrors({
          ...errors,
          first_nameError,
        });
      }
      if (!contactInfo?.last_name.trim().length) {
        last_nameError = "Last name is required.";
        setErrors({
          ...errors,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.phone.trim().length) {
        phoneError = "Phone number is required.";
        setErrors({
          ...errors,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!EMAIL_REGX.test(contactInfo.email)) {
        emailError = "Email is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.password.trim().length) {
        passwordError = "Password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (contactInfo?.password && contactInfo?.password.trim().length < 8) {
        passwordError = "password should be at least 8 characters long. ";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (!contactInfo?.confirm_password.trim().length) {
        confirm_passwordError = "Confirm password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,

          confirm_passwordError,
        });
      }

      if (contactInfo.password !== contactInfo.confirm_password) {
        confirm_passwordError = "password mismatch";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
          confirm_passwordError,
        });
      }
      return;
    }

    dispatch(AuthAction.SignUp(contactInfo, () => setOpenModal(true)));
  };

  const {
    first_nameError,
    last_nameError,
    phoneError,
    emailError,
    passwordError,
    confirm_passwordError,
  } = errors;

  return (
    <Row gutter={[0, 20]} style={{ marginTop: "40px", marginBottom: "20px" }}>
      <Col span={24}>
        <Row justify="start">
          <Col span={24} className="text-left">
            <img src={CreateProfile} />
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
            marginBottom: "30px",
          }}
        >
          <Row justify="center">
            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding"
            >
              <Row>
                <Col span={24}>
                  <TextInput
                    label={"Title"}
                    name="title"
                    onChange={onChangeContactInfo}
                    value={contactInfo.title}
                  />
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"First Name"}
                    required
                    name="first_name"
                    onChange={onChangeContactInfo}
                    value={contactInfo.first_name}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {first_nameError && first_nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Last Name"}
                    required
                    name="last_name"
                    onChange={onChangeContactInfo}
                    value={contactInfo.last_name}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {last_nameError && last_nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Phone Number"}
                    required
                    name="phone"
                    maxLength={15}
                    onChange={handleChange}
                    value={contactInfo.phone}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {phoneError && phoneError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding logincardStyling"
            >
              <Col className="login-card">
                <h2 className="text-left">Login Credentials</h2>
              </Col>
              <Row justify="center" gutter={[10, 0]}>
                <Col span={22}>
                  <TextInput
                    label={"Email Address"}
                    required
                    name="email"
                    onChange={onChangeContactInfo}
                    value={contactInfo.email}
                  />
                  <Row justify="end">
                    <Col span={22} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {emailError && emailError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={22}>
                  <TextInput
                    label={"Password"}
                    required
                    type="password"
                    name="password"
                    onChange={onChangeContactInfo}
                    value={contactInfo.password}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {passwordError && passwordError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={22}
                  style={{ paddingBottom: "20px", marginBottom: "20px" }}
                >
                  <TextInput
                    label={"Confirm Password"}
                    required
                    type="password"
                    name="confirm_password"
                    onChange={onChangeContactInfo}
                    value={contactInfo.confirm_password}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      <span className="danger-color text-right">
                        {confirm_passwordError && confirm_passwordError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Row justify="end" style={{ marginTop: "40px", marginBottom: "50px" }}>
          <Col xs={24} sm={24} md={12} lg={6} xl={4}>
            {!loader ?
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "100%",
                }}
                onClick={() => onSubmit()}
              >
                CREATE PROFILE
              </Button>
              :
              <Row justify="end" align="middle">
                <Col className="text-left" xs={6} sm={6} md={10} lg={8} xl={8}>
                  <img src={LoaderGif} height={"60"} width={"60"} />
                </Col>
              </Row>
            }

          </Col>
        </Row>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => {
                  setOpenModal(false);
                  history.push("/signin");
                }}
              >
                Done
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Profile_success} />
          </Col>
          <Col span={18} style={{ textAlign: "center" }}>
            <span>Your profile was successfully created.</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
};

export default Register;
